import { attempt } from "@omni/utils/function.utils";

import { parseISO, splitDate } from "./date";

export const parseDateOfBirth = (dateOfBirth?: string | null) => {
    let dateOfBirthDay;
    let dateOfBirthMonth;
    let dateOfBirthYear;

    if (dateOfBirth) {
        const dob = attempt(() => splitDate(parseISO(dateOfBirth)), {});
        const { day, month, year } = dob;
        dateOfBirthDay = day?.toString();
        dateOfBirthMonth = month?.toString();
        dateOfBirthYear = year?.toString();
    }

    return {
        dateOfBirthDay,
        dateOfBirthMonth,
        dateOfBirthYear
    };
};
